import { Button, ButtonProps } from '@fluentui/react-components'
import * as React from 'react'
import { ReactElement, useState } from 'react'
import LoadingIcon from '../../../components/Icon/LoadingIcon'

type SubmittingButtonProps = Omit<ButtonProps, 'onClick'> & {
    onClick: () => Promise<any>

    isSubmitting?: boolean
    setIsSubmitting?: (isSubmitting: boolean) => void
}

export default function SubmittingButton(props: SubmittingButtonProps): ReactElement {
    const [isSubmitting, setIsSubmitting] = useState(false)

    return (
        <Button
            {...(props as ButtonProps)}
            disabled={isSubmitting || props.isSubmitting || props.disabled}
            icon={isSubmitting ? <LoadingIcon /> : props.icon}
            onClick={async () => {
                try {
                    setIsSubmitting(true)
                    props.setIsSubmitting?.(true)
                    await props.onClick()
                } catch (e) {
                    console.error(e)
                    setIsSubmitting(false)
                    props.setIsSubmitting?.(false)
                } finally {
                    setIsSubmitting(false)
                    props.setIsSubmitting?.(false)
                }
            }}
        />
    )
}
